import { useEffect, useRef } from 'react';

// Has the user actually touched this pedigree yet?
//
// The second gate behind TGCLOUD-1665 (see editSignalPolicy.js). A layout write
// that arrives before any pointer or key input cannot be the user's, whoever
// produced it — which is what makes this a backstop for automatic writers nobody
// has taught the latch about yet.
//
// Listens on the DOCUMENT, not the instance's container: MUI dialogs (Bulk edit,
// the person-record modals) render through a portal outside the pedigree's DOM
// subtree, so a container listener would miss real edits made inside them. Only
// one workspace tab is active at a time, so document-level input while `enabled`
// belongs to this instance.
//
// Capture phase, so a handler that calls stopPropagation cannot hide the input
// from us. The flag is intentionally sticky: once someone has worked in this
// pedigree, later automatic writes are the latch's problem, not this gate's.
//
// Lives in its own module so the wiring — attach only when enabled, arm on both
// input kinds, detach on cleanup — is testable without mounting the chart.
export function useUserInteractionFlag(enabled) {
  const interacted = useRef(false);

  useEffect(() => {
    if (!enabled) return;
    const note = () => {
      interacted.current = true;
    };
    document.addEventListener('pointerdown', note, true);
    document.addEventListener('keydown', note, true);
    return () => {
      document.removeEventListener('pointerdown', note, true);
      document.removeEventListener('keydown', note, true);
    };
  }, [enabled]);

  return interacted;
}
